import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import { Button } from "@mui/material";
import { useContext } from "react";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import DirectorEmployeeSelect from "./DirectorEmployeeSelect";
import ProductClassLSelect from "./ProductClassLSelect";
import ProductClassMSelect from "./ProductClassMSelect";
import ProductClassSSelect from "./ProductClassSSelect";
import TaxSelect from "./TaxSelect";
import SalesRecordProductTypeSelect from "./SalesRecordProductType";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規商品登録ページ
export default function ProductInfo(props) {
  const { product, isUpdateMode = false } = props;

  // 画面ステータスをcontextから取得
  const { isChanged, setChanged } = useContext(ScreenStatusContext);

  // 入力変更時処理
  const onChangeProductInput = (value, prop) => (event) => {
    let valueChanged = product.Value[prop] !== value;
    product.handleChange(value, prop);
    setChanged(isChanged || valueChanged);
  };

  return (
    <TableContainer component={Box}>
      {/* <Button onClick={() => console.log(product.Value)}>Check State</Button> */}
      <Table>
        <TableBody>
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  商品コード&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) =>
                  onChangeProductInput(e.target.value, "productId")(e)
                }
                value={product.Value.productId}
                sx={{ width: 400 }}
                disabled={isUpdateMode}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  商品名&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) =>
                  onChangeProductInput(e.target.value, "productName")(e)
                }
                value={product.Value.productName}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  商品名カナ&nbsp;
                </Grid>
                {/* <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid> */}
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) =>
                  onChangeProductInput(e.target.value, "productKana")(e)
                }
                value={product.Value.productKana}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  原票商品種別&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ paddingBlock: 0.5 }}
              >
                <SalesRecordProductTypeSelect
                  onChange={(e) =>
                    onChangeProductInput(
                      e.target.value,
                      "salesRecordProductTypeCd"
                    )(e)
                  }
                  value={product.Value.salesRecordProductTypeCd}
                />
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  部門名&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ paddingBlock: 0.5 }}
              >
                <ProductClassLSelect
                  onChange={(e) =>
                    onChangeProductInput(e.target.value, "productClassLId")(e)
                  }
                  value={product.Value.productClassLId}
                />
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  中分類名&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ paddingBlock: 0.5 }}
              >
                <ProductClassMSelect
                  onChange={(e) =>
                    onChangeProductInput(e.target.value, "productClassMId")(e)
                  }
                  value={product.Value.productClassMId}
                  productClassLId={product.Value.productClassLId}
                />
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  小分類名&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ paddingBlock: 0.5 }}
              >
                <ProductClassSSelect
                  onChange={(e) =>
                    onChangeProductInput(e.target.value, "productClassSId")(e)
                  }
                  value={product.Value.productClassSId}
                  productClassMId={product.Value.productClassMId}
                />
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  税種&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ paddingBlock: 0.5 }}
              >
                <TaxSelect
                  onChange={(e) =>
                    onChangeProductInput(e.target.value, "taxId")(e)
                  }
                  value={product.Value.taxId}
                />
              </Grid>
            </TableCell>
          </TableRow>

          {/* 集計コード */}
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  集計&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) =>
                  onChangeProductInput(e.target.value, "summarizeProductId")(e)
                }
                value={product.Value.summarizeProductId}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>

          {/* 経済連コード */}
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  経済連&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) =>
                  onChangeProductInput(e.target.value, "keizairenCd")(e)
                }
                value={product.Value.keizairenCd}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>
          {/* 担当者 */}
          <TableRow>
            <TableCell sx={infoTableCellSx}>
              <Grid container>
                <Grid item>担当者&nbsp;</Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{ paddingBlock: 0.5 }}
              >
                <DirectorEmployeeSelect
                  onChange={(e) =>
                    onChangeProductInput(
                      e.target.value,
                      "directorEmployeeId"
                    )(e)
                  }
                  value={product.Value.directorEmployeeId}
                />
              </Grid>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
